import { Flex, Modal } from 'antd'
import { FormattedMessage } from 'react-intl'
import Header from '../SelectModal/Header'
import Option from '../SelectModal/Option'
import { FiatProvider } from '../../types'
import { lang } from './lang'

type Props = {
  isOpen: boolean
  onClose: () => void
  options: FiatProvider[]
  selectedProvider: FiatProvider | null
  onSelectProvider: (provider: FiatProvider | null) => void
}

export default function FiatProviderSelect({ isOpen, onClose, options, selectedProvider, onSelectProvider }: Props) {
  const handleSelectProvider = (provider: FiatProvider) => {
    onSelectProvider?.(provider)
    onClose
  }

  return (
    <Modal open={isOpen} footer={false} onCancel={onClose} width={408}>
      <Flex vertical gap={16}>
        <Header
          title={<FormattedMessage {...lang.title} />}
          subtitle={<FormattedMessage {...lang.subtitle} values={{ amount: options.length }} />}
        />
        <Flex vertical>
          {options.map((provider, key) => (
            <Option
              key={key}
              icon={provider.icon}
              iconSize={20}
              code={provider.payment_method_name}
              isSelected={provider.payment_method === selectedProvider?.payment_method}
              onClick={() => handleSelectProvider(provider)}
            />
          ))}
        </Flex>
      </Flex>
    </Modal>
  )
}
